import APIClient from '@/shared/http/clients/api'

const resourceName = 'motivo'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetAllSituacaoActive = (situacao, config = {}) => APIClient.get(`${APICore}/${resourceName}/?situacao=${situacao}&inactive=0&sort=nome,asc&size=500`, config)
const GetAllSituacao = (situacao, config = {}) => APIClient.get(`${APICore}/${resourceName}/?situacao=${situacao}&sort=name,asc&size=500`, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const ChangeStatus = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

const ReasonLossRepository = {
  GetAll,
  GetAllSituacao,
  GetAllPaging,
  GetById,
  Create,
  ChangeStatus,
  Update,
  Delete,
  Search,
  GetAllSituacaoActive
}

export default ReasonLossRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/reason.js